// extracted by mini-css-extract-plugin
module.exports = {"footer":"x_bB","footerWrapper":"x_bC","companyAddress":"x_bD","kofiLink":"x_bF","siteInfo":"x_bG","copyright":"x_bH","copyrightImage":"x_bJ"};